import './new-provider-type.scss';

import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";
import { Button } from "primereact/button";

import HeaderContent from "@shared/ui/header-content/header-content";
import FormProviderType from "../form-provider-type/form-provider-type";
import { useNewProviderType } from './new-provider-type.hook';

export function NewProviderType() {  
  const {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useNewProviderType();

  return (
    <div id="NewProviderType" className="provider-type">
      <HeaderContent
        title={<h1>New Provider Type</h1>}
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
            <FormProviderType />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewProviderType;